import { API } from 'aws-amplify';
import { 
	SaveInStorage,
	GetFromStorage,
	RemoveAttrInStorage
} from '@/vessi.utils';
import * as InfoContribuyente from '@/library/utils/info-contribuyente';
import router from '@/router';

let currentSucursalesApi;

export default {
/*	getEmpresas: async function( {commit, dispatch, state, rootState, getters}, _limit=750 ){

		let empresas = [];
		let exitCondition = false;
		let currentOffset = 0;
		let user = rootState.usuario.username;

		// console.log('ruser', rootState.usuario)

		let rut = user.split('-')[0];

		commit('resetEmpresas', getters['seleccionada']);

		let apiname = 'apiBoletaSII';
		let apipath = '/get-empresas';

		state.isloading = true;

		let getLoteEmpresas = async function( limit, offset ){

			let params = {
				queryStringParameters: {
					usuario: rut,
					limit: limit,
					offset: offset
				},
				headers: {}
			};

			try{
				let resp = await API.get(apiname, apipath, params);
				// en caso de que no haya ocurrido una excepcion en la llamada a la api
				// se retorna la respuesta 
				let empresas = resp;
				if( Array.isArray(empresas) ){
					return empresas;
				}else{
					return false;
				}
			}catch(err){
				console.log(err);
				// en caso de excepcion se retorna estado 1 y el error
				return false;
			}
		}

		while( !exitCondition ){

			let resp = await getLoteEmpresas( _limit , currentOffset );
			
			if( !Array.isArray(resp) )
				exitCondition = true;
			else{
				currentOffset+= resp.length;
				commit('addEmpresas', resp);

				if( resp.length != _limit )
					exitCondition = true;
			}
		}

		state.isloading = false;
	},	*/
	getEmpresas: async function({commit, dispatch, state, rootState, getters}/*, _limit=750*/) {
		let user = rootState.usuario.username;
		// let rut = user.split('-')[0];

		commit('resetEmpresas', getters['seleccionada']);
		state.isloading = true;
		
		// TODO posiblemente paginar resultados.
		// coberg 07-ago-2020 autoriza que se traigan todos por mientras
		let succFun = function(res) {
			state.isloading = false;
			let contribuyentesUsuario = res.data;

			rootState.usuario.permisos = contribuyentesUsuario.secciones;
			commit('addEmpresas', contribuyentesUsuario);
			// if( getters['lista'].length === 1 )
			if( !getters['seleccionada'] )	
				dispatch('selectEmisor', getters['lista'][0]);
		};
		
		let errFun = function(err) {
			console.log('Error al cargar contribuyentes emisores asociados al usuario actual');
		};
		
		InfoContribuyente.emisoresUsuario(user, succFun, errFun);
	},
	selectDefaultEmisor: function( {dispatch, rootState, getters}, payload={} ){

		if( !!getters['seleccionada'] )	return;

		// emisor por defecto en storage
		let emisorDefault = GetFromStorage('emisor_seleccionado');

		// username actual
		let cUser = rootState.usuario.username;
		// username en storage
		let sUser = GetFromStorage('user');

		if( !!emisorDefault 
			&& typeof emisorDefault == 'object' 
			&& cUser == sUser 
			&& !!cUser
		){
			if( emisorDefault.hasOwnProperty('rut') )
				dispatch('selectEmisor', emisorDefault);
		}else if(cUser != sUser || !cUser){
			RemoveAttrInStorage('emisor_seleccionado');
		}
	},
	selectEmisor: async function( {commit,dispatch, rootState}, emisor ){
		commit('select', emisor);
		const currentRouteName = router.currentRoute.name;
		const calRouteName = 'calculadora-botonera';

		// Datos emisor
		let rutUsuario = rootState.usuario.username;
		let rutContribuyente = emisor.rut;

		commit('usuario/ACT_CANTIDAD', [], {root: true})

		rootState.usuario.isloadingPermisos = true;

		InfoContribuyente.infoEmisorUsuario(rutContribuyente,rutUsuario,
			function(res){ 
				let permisos = res.data.secciones;
				let esRepresentanteLegal = res.data.esRepresentanteLegal;
				
				rootState.usuario.isloadingPermisos = false;
				rootState.usuario.permisos = permisos;
				rootState.usuario.esRepresentante = esRepresentanteLegal || false;
			}, 
			function(err){ 
				rootState.usuario.isloadingPermisos = false;
			});

		if( currentRouteName !== calRouteName )	router.push({name:calRouteName})
	},
}